/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents details about a Stripe Payment Method created for a company
 * @export
 * @interface BillingPaymentMethod
 */
export interface BillingPaymentMethod {
    /**
     * 
     * @type {number}
     * @memberof BillingPaymentMethod
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof BillingPaymentMethod
     */
    status: BillingPaymentMethodStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BillingPaymentMethod
     */
    type: BillingPaymentMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BillingPaymentMethod
     */
    walletType: BillingPaymentMethodWalletTypeEnum | null;
    /**
     * The last 4 digits of the assigned card
     * @type {string}
     * @memberof BillingPaymentMethod
     */
    last4: string;
    /**
     * 
     * @type {string}
     * @memberof BillingPaymentMethod
     */
    displayName: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillingPaymentMethod
     */
    isDefault: boolean;
    /**
     * The expiry month of the card
     * @type {number}
     * @memberof BillingPaymentMethod
     */
    cardExpMonth: number | null;
    /**
     * The expiry year of the card
     * @type {number}
     * @memberof BillingPaymentMethod
     */
    cardExpYear: number | null;
    /**
     * 
     * @type {string}
     * @memberof BillingPaymentMethod
     */
    cardBrand: string | null;
}

/**
* @export
* @enum {string}
*/
export enum BillingPaymentMethodStatusEnum {
    Expired = 'Expired',
    MandateFailed = 'Mandate Failed',
    PendingMandate = 'Pending Mandate',
    MandateRevoked = 'Mandate Revoked',
    Valid = 'Valid'
}
/**
* @export
* @enum {string}
*/
export enum BillingPaymentMethodTypeEnum {
    Card = 'card',
    BacsDebit = 'bacs_debit',
    Unknown = 'unknown'
}
/**
* @export
* @enum {string}
*/
export enum BillingPaymentMethodWalletTypeEnum {
    ApplePay = 'apple_pay',
    GooglePay = 'google_pay'
}


/**
 * Check if a given object implements the BillingPaymentMethod interface.
 */
export function instanceOfBillingPaymentMethod(value: object): value is BillingPaymentMethod {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('walletType' in value) || value['walletType'] === undefined) return false;
    if (!('last4' in value) || value['last4'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    if (!('cardExpMonth' in value) || value['cardExpMonth'] === undefined) return false;
    if (!('cardExpYear' in value) || value['cardExpYear'] === undefined) return false;
    if (!('cardBrand' in value) || value['cardBrand'] === undefined) return false;
    return true;
}

export function BillingPaymentMethodFromJSON(json: any): BillingPaymentMethod {
    return BillingPaymentMethodFromJSONTyped(json, false);
}

export function BillingPaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingPaymentMethod {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'type': json['type'],
        'walletType': json['walletType'],
        'last4': json['last4'],
        'displayName': json['displayName'],
        'isDefault': json['isDefault'],
        'cardExpMonth': json['cardExpMonth'],
        'cardExpYear': json['cardExpYear'],
        'cardBrand': json['cardBrand'],
    };
}

  export function BillingPaymentMethodToJSON(json: any): BillingPaymentMethod {
      return BillingPaymentMethodToJSONTyped(json, false);
  }

  export function BillingPaymentMethodToJSONTyped(value?: BillingPaymentMethod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'type': value['type'],
        'walletType': value['walletType'],
        'last4': value['last4'],
        'displayName': value['displayName'],
        'isDefault': value['isDefault'],
        'cardExpMonth': value['cardExpMonth'],
        'cardExpYear': value['cardExpYear'],
        'cardBrand': value['cardBrand'],
    };
}

